/* eslint-disable jsx-a11y/anchor-is-valid */
import { Fragment, useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { useThemeMode } from '_metronic/partials'
import Datetime from 'react-datetime'
// import { extractSingleBarChart } from 'Utils/ApexChartsTooltipsExtractration'
// import formatNumberCommas from 'Utils/formatNumberCommas'
// import { STANDARD_COLOR, BUSINESS_COLOR, ENTERPRISE_COLOR } from 'Configuration/Colors/Graph'
import { useProjectStore } from 'Store/Project'
import moment from 'moment'
import 'moment-timezone'

const Progress7DaysChart = () => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()

  const { id } = useParams<{ page: string; id: string }>()
  const [from, setFrom] = useState(moment().subtract(6, 'days').startOf('day').toISOString())
  const [to, setTo] = useState(moment().endOf('day').toISOString())
  const { weeklyReport, getWeeklyReport } = useProjectStore()

  const fetchData = async () => {
    if (id) {
      await getWeeklyReport(parseInt(id), from, to)
    }
  }

  const refreshChart = (data: any[]) => {
    if (!chartRef.current) {
      return
    }

    const chart = new ApexCharts(chartRef.current, getChartOptions(data))
    if (chart) {
      chart.render()
    }

    return chart
  }

  useEffect(() => {
    const chart = refreshChart(weeklyReport ?? [])

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef, mode, weeklyReport])

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [from, to])

  return (
    <Fragment>
      <div className='mb-5 d-flex flex-column flex-sm-row justify-content-sm-end align-items-sm-center gap-4'>
        <div>
          <div className='fs-6 mb-3'>วันที่เริ่มต้น</div>
          <Datetime
            locale='en'
            dateFormat='DD/MM/YYYY'
            timeFormat={false}
            renderInput={props => {
              return (
                <input
                  {...props}
                  autoComplete='off'
                  placeholder='เลือกวันที่'
                  value={moment(from).isValid() ? props.value : ''}
                />
              )
            }}
            closeOnClickOutside
            className='filter-date-input w-100 z-4'
            value={moment(from).format('DD/MM/YYYY')}
            onChange={(val: any) => setFrom(moment(val).startOf('day').toISOString())}
            isValidDate={(currentDate: any) => {
              return currentDate.isAfter(moment(to).subtract(1, 'day')) === false
            }}
          />
        </div>
        <div className='mt-5 mt-sm-0'>
          <div className='fs-6 mb-3'>วันที่สิ้นสุด</div>
          <Datetime
            locale='en'
            dateFormat='DD/MM/YYYY'
            timeFormat={false}
            renderInput={props => {
              return (
                <input
                  {...props}
                  autoComplete='off'
                  placeholder='เลือกวันที่'
                  value={moment(to).isValid() ? props.value : ''}
                />
              )
            }}
            closeOnClickOutside
            className='filter-date-input w-100 z-4'
            value={moment(to).format('DD/MM/YYYY')}
            onChange={(val: any) => setTo(moment(val).endOf('day').toISOString())}
            isValidDate={(currentDate: any) => {
              return currentDate.isBefore(moment(from)) === false
            }}
          />
        </div>
      </div>

      {/* begin::Chart */}
      <div
        ref={chartRef}
        id='kt_charts_member_types_chart'
        style={{ height: '300px' }}
        className='card-rounded-bottom'></div>
      {/* end::Chart */}
    </Fragment>
  )
}

function getChartOptions (weeklyReport: any[]): ApexOptions {
  return {
    grid: {
      padding: {
        top: 60,
      },
    },
    series: [
      {
        name: 'ตอกสำเร็จ',
        data: weeklyReport.map(report => report.totalCompleted),
      },
      {
        name: 'ตอกเสีย',
        data: weeklyReport.map(report => report.totalWasted),
      },
    ],
    colors: ['#1BC5BD', '#F64E60'],
    chart: {
      type: 'bar',
      height: 300,
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        distributed: false,
        borderRadius: 8,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      type: 'category',
      // title: {
      //   text: 'วันที่',
      // },
      categories: weeklyReport.map(report => moment(report.date).format('DD MMM')),
    },
    fill: {
      opacity: 1,
    },
    legend: {
      show: true,
      position: 'top',
      horizontalAlign: 'right',
      floating: true,
      markers: {
        width: 12,
        height: 12,
        radius: 6,
      },
      formatter: function (seriesName) {
        return seriesName + '\n'
      },
      onItemHover: {
        highlightDataSeries: true,
      },
    },
    // tooltip: {
    //   custom: function ({ w, dataPointIndex, seriesIndex }) {
    //     const datas = w.globals.initialSeries
    //     const dataColor = w.globals.colors

    //     const extractedData = extractSingleBarChart(datas, dataColor, dataPointIndex, seriesIndex)

    //     return `<div class="bg-kumopack-base-black py-2 px-5 text-kumopack-base-white">
    // 						    <div>${formatNumberCommas(extractedData.total)} users</div>
    // 					</div>`
    //   },
    // },
  }
}

export default Progress7DaysChart
